module.exports = __webpack_public_path__ + "9543924282e5bcc8917943c7d3e14dee.pdf";